// extracted by mini-css-extract-plugin
export default {"tag":"inactive-timer_tag__gkk-X","number":"inactive-timer_number__uy3HO","--red":"inactive-timer_--red__9W+3A","--gray":"inactive-timer_--gray__ReIU1"};